module.exports = __webpack_public_path__ + "b53ea39baceede5ec7e5724d1f5b957a.png";